import * as yup from "yup";

//hospital Branch
export const hospitaBranchDialogValidation = yup.object().shape({
  jobLocationHospitalName: yup
    .string()
    .required("Job Location Hospital Name is required"),
  jobLocationBranchName: yup
    .string()
    .required("Job Location Brach Name is required"),
  company: yup.string().required("Company is required"),
  corporate: yup.string().required("Corporate is required"),
  cityName: yup.string().required("Job Address City Name is required"),
  // reverseCharges:yup.string().required()
  jobLocationState: yup.string().required("Branch State is required"),
});


export const hospitalBranchFormValidation=yup.object().shape({
    // jobLocationHospitalName:yup.string().required("Job Hospital Name is required"),
    // jobLocation: yup.object().shape({
    //   address: yup.object().shape({
    //     lat: yup.string().required("Latitude is required"),
    //     long: yup.string().required("Longitude is required"),
    //   }),
    // }),
    // jobLocation: yup.object().shape({
    //   address: yup.object().shape({
       
    //     lat: yup.string().required("Job Latitude is required"),
    //     long: yup.string().required("Job Longitude is required")
    //   })
    // }),
//     ...(isNewBranch && {
//     servicefeePercent: yup
//       .number()
//       .typeError("Service Fee must be a number")
//       // .required("Service Fee is required")
//       .max(100, "Service Fee cannot be more than 100%")
//       .min(0, "Service Fee cannot be negative"),
//     paymentDuePeriodDays: yup.string().required("Payment Due Period Days is required"),
//     shiftApprovalBufferDays: yup.string().required("Shift Approval Buffer Days is required"),
//     billingCycle: yup.string().required("Billing Cycle is required"),
//     latePaymentFeePercent: yup
//       .number()
//       .typeError("Late Payment Fee must be a number")
//       .required("Late Payment Fee is required")
//       .max(100, "Late Payment Fee cannot be more than 100%")
//       .min(0, "Late Payment Fee cannot be negative"),
//     hrEmail:yup.string()?.required("HR Email is required")?.email("Invalid email format"),
//     hrContact:yup.string()?.required("HR Phone is required").matches(/^[0-9]{10}$/, "Invalid phone number"),
//     financeEmail:yup.string()?.required("Finance Email is required").email("Invalid email format"),
//     financeContact:yup.string()?.required("Finance Phone is required").matches(/^[0-9]{10}$/, "Invalid phone number"),
//     // otherEmail:yup.string()?.email("Invalid email format"),
//     // otherPhone:yup.string()?.matches(/^[0-9]{10}$/, "Invalid phone number"),
//     // otherPhoneArray:yup.array().of(yup.string().matches(/^[0-9]{10}$/, "Invalid phone number")),
//     billingName:yup.string().required("Name is required"),
//     completeBillingAddress:yup.string().required("Address is required"),
//     billingCity:yup.string().required("City is required"),
//     billingState:yup.string().required("State is required"),
//     billingCountry:yup.string().required("Country is required"),
//     billingPinCode:yup.string().required("Pin Code is required").matches(/^[0-9]{6}$/, "Pincode must be exactly 6 digits"),
//     gstNumber:yup.string().required("GST Number is required"),
//     panNumber:yup.string().required("Pan Number is required"),
//     contractDetails: yup.array().of(
//         yup.object().shape({
//           contractStartDate: yup.date()
//             .required("Start date is required")
//             .test(
//               'is-before-end',
//               'Start date must be before end date',
//               function(value) {
//                 const { contractEndDate } = this.parent;
//                 if (!value || !contractEndDate) return true;
//                 return new Date(value) <= new Date(contractEndDate);
//               }
//             ),
//           contractEndDate: yup.date()
//             .required("End date is required"),
//           contractCopy: yup
//             .object({
//               fileUrl: yup.string().required("Contract copy is required"),
//             })
//             .required("Contract copy is required"),
//         })
//       ).min(1, "At least one contract is required"),
//     bankName:yup.string().required("Bank Name is required"),
//     branchName:yup.string().required("Branch Name is required"),
//     accountNumber:yup.string().required("Account Number is required"),
//     ifscCode:yup.string().required("IFSC Code is required"),
//     oneTimeFeeAmount: yup
//     .number()
//     .typeError("One Time Fee Amount must be a number")
//     .when("isOneTimeFee", {
//       is: true,
//       then: (schema) =>
//         schema
//           .required("One Time Fee Amount is required")
//           .min(1, "Amount must be greater than 0"),
//       otherwise: (schema) => schema.notRequired(),
//     }),
//  })}
})
export const DepartmentDialogValidation=yup.object().shape({
    company:yup.string().required("company is required"),
    branch:yup.string().required("branch is required"),
    departmentType:yup.string().required("department type is required")
})



export const CompanyValidation=yup.object().shape({
    corporateName:yup.string().required(),
    companies:yup.string().required(),
    companyType:yup.string().required(),
    isTopHospital:yup.string().required()
})


//Corporate
export const corporateDialogValidation=yup.object().shape({
    name:yup.string().required("Corporate Name is Required"),
    corporateType:yup.string().required("Corporate Type  is Required"),
    logoLocation:yup.string().required("Logo Location is Required")
})

export const ApplicationDialogValidation = yup.object().shape({
    organization: yup.string().required("Organization is required"),
professional: yup.string().required("Profession is required"),
job: yup.string().required("Job is required"),
state: yup.string().required("State is required")
  });


export const ratesValidation = yup.object().shape({
  minRate: yup.string().required("Min Rate is required"),
  marginHospital:yup.string().required("Margin Hospital is Required"),
  marginCandidate: yup.string().required("Margin Candidate is required"),
  profession: yup.string().required(),
  qualification: yup.string().required(),
  department: yup.string().required().required("Department is required"),
  branch: yup.string().required(),
  specialization: yup.string().required(),
  experience: yup.string().required(),
});

 export const monetizationValidation=yup.object().shape({ 
    city:yup.string().required(),
    role:yup.string().required(),
    department:yup.string().required(),
    specialization:yup.string().required(),
    numExperience:yup.string().required(),
    valueType:yup.string().required(),
    value:yup.string().required(),
 })

 export const videoValidation=yup.object().shape({ 
    index:yup.string().required(),
    title:yup.string().required(),
    url:yup.string().required(),
 })


//  export const permanentJobCreateValidSchema = yup.object().shape({
//     department: yup.string().required("Department is required"),
//     // "salary.type": yup.string().required("Salary Type is Required"),
//     // "salary.min": yup.string().required("Salary Min is Required"),
//     // "salary.max": yup.string().required("Salary Max is Required"),
//     // "salary.currency": yup.string().required("Salary Currency is Required"),
    
//   });


  export const permanentJobCreateValidations = yup.object().shape({
    department: yup.string().required("Department is required"),
    // "salary.type": yup.string().required("Salary Type is Required"),
    // "salary.min": yup.string().required("Salary Min is Required"),
    // "salary.max": yup.string().required("Salary Max is Required"),
    // "salary.currency": yup.string().required("Salary Currency is Required"),
  });